module.exports = __webpack_public_path__ + "img/mail_icon.059df8e6.png";